import timeFormat from '../../packages/utils/timeFormat'
/**
 *
 * @param {String} dateTime
 * @param {string} format
 */
export default function timeFrom(dateTime = null, format = 'YYYY-MM-DD') {
  if (!dateTime) dateTime = Number(new Date())
  if (dateTime.toString().length === 10) dateTime *= 1000
  let timestamp = +new Date(Number(dateTime))
  let timer = (Number(new Date()) - timestamp) / 1000
  let tips = ''
  switch (true) {
    case timer < 300:
      tips = '刚刚'
      break
    case timer >= 300 && timer < 3600:
      tips = parseInt(timer / 60) + '分钟前'
      break
    case timer >= 3600 && timer < 86400:
      tips = parseInt(timer / 3600) + '小时前'
      break
    case timer >= 86400 && timer < 2592000:
      break
    default:
      if (format === false) {
        if (timer >= 2592000 && timer < 365 * 86400) {
          tips = parseInt(timer / (86400 * 300)) + '个月前'
        } else {
          tips = parseInt(timer / (86400 * 365)) + '年前'
        }
      } else {
        tips = timeFormat(timestamp, format)
      }
  }
  return tips
}



// WEBPACK FOOTER //
// ./packages/utils/timeFrom.js